import { post } from '..';

const leaveUserGroup = (
  DeletedUserId: string,
  UserGroupId: string,
  GroupName: string,
  LocationId: string,
) => post(`users/v2/user-groups/members/${UserGroupId}`, {
  UserId: [],
  DeletedUserId: [DeletedUserId],
  LocationId,
  GroupName,
});

export default leaveUserGroup;
